import { Suspense } from 'react';
import { useParams } from 'react-router-dom';

import DatasetsList from '@/components/Datasets';
import DataSourceCreateModal from '@/components/Datasets/Create/datasources';
import FallBack from '@/components/SuspenseFallBack';
import { DatasetsRoutes } from '@/routes';

const DatasetsPage = () => {
  const { datasetId } = useParams();

  if (!datasetId) return <DatasetsList />;

  return (
    <Suspense fallback={<FallBack />}>
      <DatasetsRoutes />
      <DataSourceCreateModal />
    </Suspense>
  );
};

export default DatasetsPage;
